import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { ProfessionalState, RootState } from './professional-types';

export const state: ProfessionalState = {
  professional: undefined,
  error: false,
};

const namespaced = true;

export const professional: Module<ProfessionalState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
